var fn = async function fn() {
  console.log("pause here");

  await doAsync();

  console.log("stopped here");
};

function doAsync() {
  return Promise.resolve();
}

export default function root() {
  fn();
}



//////////////////
// WEBPACK FOOTER
// ./input.js
// module id = 0
// module chunks = 0